// 服务器行业
import { getPartitioningChild } from '@/utils/api'

export default {
  state: {
    // 视频会议细分市场
    searchVideoMarketList: [],
  },
  getters: {},
  mutations: {
    setSearchVideoMarketList(state, data) {
      state.searchVideoMarketList = [...data]
    },
  },
  actions: {
    async getSearchVideoMarketList({ commit }) {
      let [err, res] = await getPartitioningChild(8)
      if (err) return
      commit('setSearchVideoMarketList', res)
    },
  }
}
